'use client';

import type { StaticBannerList } from './StaticBanner';
import { StaticBanner } from './StaticBanner';

interface BannerProps {
  policyBannerTypeList?: string[];
  idx: string;
}

export const Banner = ({ policyBannerTypeList, idx }: BannerProps) => {
  if (policyBannerTypeList?.length) {
    const bannerList: StaticBannerList[] = [];

    if (policyBannerTypeList.includes('육아')) {
      bannerList.push('육아생활');
    }

    if (bannerList.length === 0) return null;

    return <StaticBanner bannerList={bannerList} className="mb-28" />;
  }

  switch (idx) {
    case '3150f149-2eb2-43d7-8ec4-165ac135a087':
      return <StaticBanner bannerList={['K 패스']} className="mb-28" />;

    default:
      return null;
  }
};
